import React from 'react';
import styles from './PlanDetailsItem.module.css';

type PlanDetailsItemProps = {
  icon?: string;
  text: string;
  value?: string;
  children?: React.ReactNode;
  column?: boolean;
  row?: boolean;
};

const PlanDetailsItem = ({ icon, text, value, children, column, row }: PlanDetailsItemProps) => (
  <div className={`${styles.container} ${styles.itemInlineWrap} ${column ? styles.column : ''} ${row ? styles.row : ''}`}>
    <span className={styles.labelInlineWrap}>{text}</span>
    <p className={styles.valueInlineWrap}>{children ?? value}</p>
  </div>
);

export default PlanDetailsItem;
